var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.isBusy,
              expression: "isBusy",
            },
          ],
          ref: "form",
          attrs: {
            model: _vm.form,
            rules: _vm.rules,
            "element-loading-spinner": "el-icon-loading",
            "label-width": "170px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "Name", prop: "name" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.canSelectUser
            ? _c(
                "el-form-item",
                { attrs: { label: "Owner", prop: "user_id" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "w-100",
                      attrs: { filterable: "" },
                      on: { input: _vm.onUserSelected },
                      model: {
                        value: _vm.form.user_id,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "user_id", $$v)
                        },
                        expression: "form.user_id",
                      },
                    },
                    _vm._l(_vm.users, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.full_name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Brand", prop: "brand_id" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "w-100",
                  attrs: { disabled: _vm.isEditMode },
                  model: {
                    value: _vm.form.brand_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "brand_id", $$v)
                    },
                    expression: "form.brand_id",
                  },
                },
                _vm._l(_vm.brands, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.title, value: item.id },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "Expiry period", prop: "expiry_period" } },
            [
              _c("el-input-number", {
                attrs: { precision: 0, min: 1 },
                model: {
                  value: _vm.form.expiry_period,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "expiry_period", $$v)
                  },
                  expression: "form.expiry_period",
                },
              }),
              _vm._v(" "),
              _c("p", [_vm._v("Contacts expire from this group in X days")]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-purple px-4 mt-5",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.store.apply(null, arguments)
                },
              },
            },
            [_vm._v("Store")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }